import React from 'react';
import { Notice } from '../Notice/Notice';
import * as S from './EndBar.styles';
export const EndBar = ({
  children,
  notice,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(S.Root, rest, notice && /*#__PURE__*/React.createElement(Notice, null, notice), children);
};